import React from 'react';
import { Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { LoginPage } from './components/auth/LoginPage';
import { Header } from './components/layout/Header';
import { Sidebar } from './components/layout/Sidebar';
import { Dashboard } from './components/dashboard/Dashboard';
import { StatisticsPage } from './components/statistics/StatisticsPage';
import { SettingsPage } from './pages/settings/SettingsPage';
import { PropertyForm } from './components/properties/forms/PropertyForm';
import { ClientForm } from './components/clients/forms/ClientForm';
import { EditClient } from './pages/EditClient';
import { ForSaleList } from './pages/ForSaleList';
import { ForRentList } from './pages/ForRentList';
import { ShortRentList } from './pages/ShortRentList';
import { SoldList } from './pages/SoldList';
import { RentedList } from './pages/RentedList';
import { ArchivedProperties } from './pages/ArchivedProperties';
import { ArchivedClients } from './pages/ArchivedClients';
import { ActiveClients } from './pages/ActiveClients';
import { EstimationsList } from './pages/EstimationsList';
import { AdminDashboard } from './components/admin/AdminDashboard';
import { PropertyEditForm } from './components/properties/forms/PropertyEditForm';
import { PromotionsPage } from './pages/PromotionsPage';
import { AddPromotionPage } from './pages/AddPromotionPage';
import { EditPromotionPage } from './pages/EditPromotionPage';
import PromotionDetailPage from './pages/PromotionDetailPage';
import { ConciergeriePage } from './pages/ConciergeriePage';
import { ConciergerieDetailPage } from './pages/ConciergerieDetailPage';
import { useAuth } from './contexts/AuthContext';

const AppLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = React.useState(false);
  const location = useLocation();
  const prevPathname = React.useRef(location.pathname);

  console.log('🟣 AppLayout render - sidebarOpen:', sidebarOpen);

  const handleCloseSidebar = React.useCallback(() => {
    console.log('🔴 handleCloseSidebar CALLED!');
    setSidebarOpen(false);
    console.log('🔴 setSidebarOpen(false) executed');
  }, []);

  React.useEffect(() => {
    // Ne fermer le sidebar QUE si la route a VRAIMENT changé (pas au premier render)
    if (prevPathname.current !== location.pathname) {
      console.log('🟠 Route changed from', prevPathname.current, 'to', location.pathname);

      if (window.innerWidth < 1024) {
        console.log('🟠 Mobile detected - closing sidebar');
        setSidebarOpen(false);
        console.log('🟠 Sidebar closed automatically');
      }

      // Mettre à jour la route précédente
      prevPathname.current = location.pathname;
    }
  }, [location.pathname]);

  return (
    <div className="min-h-screen bg-gray-50 dark:bg-gray-900">
      <Sidebar isOpen={sidebarOpen} onClose={handleCloseSidebar} />
      <div className="lg:pl-72">
        <Header onMenuClick={() => setSidebarOpen(true)} />
        <main className="py-10">
          <div className="px-4 sm:px-6 lg:px-8">
            <Routes>
              <Route path="" element={<Dashboard />} />
              <Route path="statistiques" element={<StatisticsPage />} />
              <Route path="settings" element={<SettingsPage />} />
              <Route path="ajouter/vente" element={<PropertyForm />} />
              <Route path="ajouter/estimation" element={<PropertyForm isEstimation={true} />} />
              <Route path="ajouter/location" element={<PropertyForm initialTransactionType="rent" />} />
              <Route path="ajouter/location-courte" element={<PropertyForm initialTransactionType="short-rent" />} />
              <Route path="modifier/:id" element={<PropertyEditForm />} />
              <Route path="ajouter/client" element={<ClientForm />} />
              <Route path="modifier/client/:id" element={<EditClient />} />
              <Route path="en-vente" element={<ForSaleList />} />
              <Route path="promotions" element={<PromotionsPage />} />
              <Route path="promotions/new" element={<AddPromotionPage />} />
              <Route path="promotions/:id" element={<PromotionDetailPage />} />
              <Route path="promotions/:id/edit" element={<EditPromotionPage />} />
              <Route path="estimations" element={<EstimationsList />} />
              <Route path="en-location" element={<ForRentList />} />
              <Route path="location-courte-duree" element={<ShortRentList />} />
              <Route path="conciergerie" element={<ConciergeriePage />} />
              <Route path="conciergerie/:id" element={<ConciergerieDetailPage />} />
              <Route path="vendus" element={<SoldList />} />
              <Route path="loues" element={<RentedList />} />
              <Route path="archives" element={<ArchivedProperties />} />
              <Route path="clients-actifs" element={<ActiveClients />} />
              <Route path="clients-archives" element={<ArchivedClients />} />
              <Route path="admin-dashboard" element={<AdminDashboard />} />
            </Routes>
          </div>
        </main>
      </div>
    </div>
  );
};

const App: React.FC = () => {
  console.log('🚀 App component rendu');
  
  return (
    <AuthProvider>
      <Routes>
        <Route path="/login" element={<LoginPage />} />
        <Route path="/*" element={
          <ProtectedRoute>
            <AppLayout />
          </ProtectedRoute>
        } />
      </Routes>
    </AuthProvider>
  );
};

export default App;